<template>
  <div>
		<el-container style="display:block;">
    <el-row :gutter="60" class="de-h-w">
			<el-col :span="6" class="de-el-col"><div class="de-title-name">数据图片:</div></el-col>
			<el-col :span="18" class="de-el-col">
				<div class="de-content">

					<div class="upload-img">
						<el-upload
						  class="avatar-uploader"
						  action="http://data3.yoooooo.com/index.php/index/data/pythonImgSaveGood"
						  :show-file-list="false"
						  :on-success="handleAvatarSuccess1"
						  style="display: inline;">

						  <img style="width: 60px;height: 60px;" v-if="addImg" :src="addImg" class="avatar">
						  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
						</el-upload>
					</div>
					<div>
						<p>1.商品主图600*600像素正方形,小于120kb,保证图片不拉伸不变形</p>
						<p>2.保证图片不拉伸不变形</p>
						<p>3.上传后的图片将自动保存</p>

					</div>
				</div>
			</el-col>
		</el-row>
		<el-row :gutter="60" class="de-h-w">
			<el-col :span="6" class="de-el-col"><div class="de-title-name">数据描述:</div></el-col>
			<el-col :span="18" class="de-el-col">
				<div class="de-content">
					<el-input type="textarea" v-model="textarea"   class="disc"></el-input>
					<p>商品描述至少3个字符,最长50个字符</p>
				</div>

			</el-col>
		</el-row>
    <el-row :gutter="60" class="de-h-w">
    	<el-col :span="6" class="de-el-col"><div class="de-title-name">多描述标签:</div></el-col>
    	<el-col :span="18" class="de-el-col">
    		<el-tag
    		  :key="tag"
    		  v-for="tag in dynamicTags"
    		  closable
    		  :disable-transitions="false"
    		  @close="handleClose(tag)">
    		  {{tag}}
    		</el-tag>
    		<el-input
    		  class="input-new-tag"
    		  v-if="inputVisible"
    		  v-model="inputValue"
    		  ref="saveTagInput"
    		  size="small"
    		  @keyup.enter.native="handleInputConfirm"
    		  @blur="handleInputConfirm"
    		>
    		</el-input>
    		<el-button v-else class="button-new-tag" size="small" @click="showInput">添加新描述</el-button>
    	</el-col>
    </el-row>
		<el-row :gutter="60" class="de-h-w biaoqian">
			<el-col :span="6" class="de-el-col"><div class="de-title-name">数据标签:</div></el-col>
			<el-col :span="18" class="de-el-col">
				<div class="de-content">
					<div>{{lableEx}}</div>
					<!-- <el-input type="textarea" disabled v-model="lableEx"   class="disc"></el-input>					 -->
				</div>

			</el-col>
		</el-row>
		<el-container class="lables-a">
			<el-row  class="la-list-a">
				<el-col :span="10" class="first-a">
					<el-row>
						<div class="search-a">
							<input type="text" v-model="searchF" @change="loadData()"/>
						</div>

					</el-row>
					<el-row class="lable-o-l-a">
						<div class="lable-o-a" v-for="(item,index) in lableFirst" :class="{'left':index%2==0,'right':index%2!=0,'choses':choseAF.indexOf(item.id)>-1&&item.id!=choses,'chosess':item.id==choses}" :key="index" @click="chose(item.id)">{{item.name}}</div>

					</el-row>
				</el-col>
				<el-col :span="4" class="centr"><img  src="../../assets/image/next.jpg"/></el-col>
				<el-col :span="10" class="two-a">
					<el-row>
						<div class="search-a">
							<input type="text" v-if="!otherLables"  v-model="searchT" @change="loadDataTwo()"/>
							<div v-if="otherLables">
								<input type="text"  v-model="otherLable" />
								<div class="addother" >
									<span @click="addLable()">+ 添加</span>
									<span @click="delLable()">- 删除</span>
								</div>
							</div>
						</div>
					</el-row>
					<el-row class="lable-o-l-a">
						<div class="lable-o-a" v-for="(item,index) in lableTwo" :class="{'left':index%2==0,'right':index%2!=0,'choses':choseAT.indexOf(item.id)>-1}" :key="index" @click="lableC(item.id,item.p_id,item.name)">{{item.name}}</div>

					</el-row>
				</el-col>
			</el-row>

		</el-container>
		<el-row :gutter="60" class="de-h-w">
			<input type="button" @click="saveDetail()" class="h-save"  value="保存"/>
		</el-row>
		</el-container>
  </div>

</template>
<style>


</style>
<script>

  export default {

    data() {
      return {
        headimg: [''],
		textarea:'',
    textarea1:'',
		dragging: null,
		itemModel:false,
		// lable:'',
		file:'',
		token:window.localStorage.getItem('token'),
		userId:window.localStorage.getItem('id'),
		url:this.$store.getters.getUrl,
		uIp:'',
		lableFirst:[],
		lableTwo:[],
		chosesT:0,
		choses:0,
		choseAF:[],
		choseAT:[],
		searchF:'',
		searchT:'',
		lable:[],
		lableEx:'',
		otherLable:'',
		otherLables:false,
    dynamicTags: [],
    inputVisible: false,
    inputValue: '',
    addImgs:'',
    addImg:''
      };
    },
		created(){
			 // var cip = returnCitySN["cip"];
			 // this.uIp = cip
// 			  if(this.$store.getters.getRole != 'admins'){
// 			  		   if(cip !='117.9.19.251' && cip !='60.27.105.250' && cip !='60.27.106.235'){
// 			  			   this.$router.push({ path: '/' })
// 			  		   }
// 			  }
      if(!window.localStorage.getItem('id')){
        this.$router.push({ path: '/' })
      }
			  this.loadData();
		},
    methods: {
      handleAvatarSuccess1(res, file){


        this.addImg = URL.createObjectURL(file.raw);
        this.addImgs = file.response.data

      },
      handleClose(tag) {
              this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
            },

            showInput() {
              this.inputVisible = true;
              this.$nextTick(_ => {
                this.$refs.saveTagInput.$refs.input.focus();
              });
            },

            handleInputConfirm() {
              let inputValue = this.inputValue;
              if (inputValue) {
                this.dynamicTags.push(inputValue);
              }
              this.inputVisible = false;
              this.inputValue = '';
            },
      handleDragStart(e,item){
			this.dragging = item;
		},
		handleDragEnd(e,item){
			this.dragging = null
		},
		//首先把div变成可以放置的元素，即重写dragenter/dragover
		handleDragOver(e) {
			e.dataTransfer.dropEffect = 'move'// e.dataTransfer.dropEffect="move";//在dragenter中针对放置目标来设置!
		},
		handleDragEnter(e,item){
			e.dataTransfer.effectAllowed = "move"//为需要移动的元素设置dragstart事件
			if(item === this.dragging){
				return
			}
			const newItems = [...this.headimg]
			console.log(newItems)
			const src = newItems.indexOf(this.dragging)
			const dst = newItems.indexOf(item)

			newItems.splice(dst, 0, ...newItems.splice(src, 1))

			this.headimg = newItems
		},
		delImg(){
			this.headimg = [''];
			this.file    = '';
		},
		getImgBase(index) {

			let event = event || window.event;
			let file = event.target.files[0];
			let reader = new FileReader();
			//这个this指向的是vue
			reader.vue  = this
			reader.readAsDataURL(file);
			//在reader的load内部，this的指向是reader，所以使用自己的数据或者封装的vue方法，请使用this.vue.XXX
			reader.onload = function () {
				file.src = this.result
				this.vue.$set(this.vue.headimg, index , file.src);
				this.vue.file = file;


			}

		},

			itemModelLeave(){
				this.itemModel = false;
			},
			saveDetail(){
				if(this.addImgs == ''){
					this.msg('请选择图片','error');
					return false;
				}

				let params =new FormData();
				params.append('token',this.token);
				params.append('userId',this.userId);
				params.append('img',this.addImgs);
        params.append('describes',this.dynamicTags.toString());
				params.append('textarea',this.textarea);
				params.append('lable',this.lableEx)
				params.append('uip',this.uIp)
				const axiosInstance = this.$axios.create({
					headers: {'Content-Type': 'multipart/form-data'},// 设置传输内容的类型和编码
					withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置

				});

				axiosInstance({
					method:'post',
					url:'http://y31p.yoooooo.com/index.php/index/data/dataAddNewf',
					data:params

				})
				.then(res=>{
					if(res.data.code == 200){
						this.msg('保存成功','success');
					}else{
						this.msg('保存失败','error');
					}
				})
				.catch(err=>{

				});

			},
			msg(msg,type){
				this.$message({
				  message: msg,
				  type: type
				});
			},
			loadData(){
				const axiosInstance = this.$axios.create({
					headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
					withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
				});
				axiosInstance({
					method:'get',
					params:{
						name:this.searchF
					},
					url:'http://y31p.yoooooo.com/index.php/index/data/lableFirstf'
				})
				.then(res=>{
					this.lableFirst = res.data;
					// console.log(res.data)
				})
				.catch(err=>{

				});
			},
			loadDataTwo(){
				const axiosInstance = this.$axios.create({
					headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
					withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
				});
				axiosInstance({
					method:'get',
					params:{
						name:this.searchT,
						p_id:this.choses
					},
					url:'http://y31p.yoooooo.com/index.php/index/data/lableTwof'
				})
				.then(res=>{
					this.lableTwo = res.data;

				})
				.catch(err=>{

				});
			},
			chose(id){
				this.choses = id;
				this.searchT = '';
        this.otherLables = true
        this.loadDataTwo();
				// if(id == 3 || id == 4 || id == 6 || id == 36 || id == 37 || id == 38 || id == 39){
				// 	this.otherLables = true
				// 	this.lableTwo = []
				// }else{
				// 	this.otherLables = false
				// 	this.loadDataTwo();
				// }


			},
			lableC(id,pId,name){
				this.chosesT = id;
				const names = pId+'-'+name;
				if(this.lable.indexOf(names)>-1){
					this.choseAF.splice(this.choseAF.indexOf(pId),1);
					this.choseAT.splice(this.choseAT.indexOf(id),1);
					this.lable.splice(this.lable.indexOf(names),1);
				}else{
					this.lable.push(names);
					this.choseAF.push(pId);
					this.choseAT.push(id);
				}
				this.lableEx =  this.lable.join(',');
			},
			addLable(){
        if(this.otherLable == ''){
          this.msg('请输入内容','error');
          return false
        }
				const names = this.choses+'-'+ this.otherLable;
				if(this.lable.indexOf(names)>-1){
					this.msg('请勿重复添加','error');
				}else{
					this.lable.push(names);
					this.choseAF.push(this.choses);
					this.lableEx =  this.lable.join(',');
					this.otherLable = ''
				}

			},
			delLable(){
        if(this.otherLable == ''){
          this.msg('请输入内容','error');
          return false
        }
				const names = this.choses+'-'+ this.otherLable;
				if(this.lable.indexOf(names)>-1){
					this.lable.splice(this.lable.indexOf(names),1);
					this.choseAF.splice(this.choseAF.indexOf(this.choses),1);
					this.lableEx =  this.lable.join(',');
					this.otherLable = ''
				}else{
					this.msg('请删除已存在的标签','error');
				}
			}



		}
	}
</script>
<style>
  .el-tag + .el-tag {
      margin-left: 10px;
    }
    .button-new-tag {
      margin-left: 10px;
      height: 32px;
      line-height: 30px;
      padding-top: 0;
      padding-bottom: 0;
    }
    .input-new-tag {
      width: 90px;
      margin-left: 10px;
      vertical-align: bottom;
    }
	.de-h-w:nth-child(1),.biaoqian {
	    margin-bottom: 20px;
	    height: 200px;
			width: 70%;
			padding-left: 20%;
			margin-top: 50px;
	  }
	  .h-save{
		margin-left: 46%;
		width: 100px;
		height: 40px;
		background-color: orange;
		border-radius: 10px;
		color: #fff;
	  }
		.de-h-w:nth-child(2) {
		  margin-bottom: 20px;
		  height: 200px;
			width: 70%;
			padding-left: 20%;
		}
    .de-h-w:nth-child(3) {
      margin-bottom: 20px;
      height: 200px;
    	width: 70%;
    	padding-left: 20%;
    }
	  .de-el-col {
	    border-radius: 4px;
		height: 100%;
	  }
		.de-title-name{
			height: 100%;
			width: 100%;
			border: #fff 0px;
			text-align: right;
		}
		.disc textarea{
			height: 90px;
			border: none;
			background: #FAEBD7;
		}
		.de-item-name{
			background: antiquewhite;
			height: 50px;
			text-align: center;
			line-height: 50px;
			float: left;
			width: 15%;
			margin-left: 10px;
			margin-bottom: 10px;
		}
		.de-item-two{
			position: absolute;
			top: 50px;
			left: 0;
			background: #FFFFFF;
			width: 97%;
			height: 50%;
			margin-left: 10px;
			box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
			border:3px solid aliceblue;
		}
		.de-search-model{
			margin-left: 20px;
			margin-top: 10px;
		}
		.de-search-model span{
			margin-left: 10px;
			font-size: 14px;
		}
		.de-search-but{
			background: #939aa0;

		}
		.de-item-model{
			margin-left: 17px;
			margin-top: 10px;
		}

		.de-item-model label{
			float: left;
			font-size: 14px;
			margin-right: 10px;
			width: 90px;
			margin-bottom: 10px;
		}

		.de-itemname{
			float: left;
			margin-left: 5px;
			margin-top: 3px;
		}


	  .de-content{
			width: 100%;
			height: 100%;
			position: relative;
			/* background: antiquewhite; */
		}
		.de-img-model{
			float: left;
			width: 33.3333%;

		}
		.de-up-de-content{
			position: relative;
			height: 180px;
			width: 185px;
			margin-left: 20px;
		}

		.de-img-up{
			background: antiquewhite;
			height: 180px;
			text-align: center;
			line-height: 180px;
			font-size: 46px;

		}
	  .up{
	        opacity:0;
	        filter:alpha(opacity=0);
	        height: 100%;
	        width: 100%;
	        position: absolute;
	        top: 0;
	        left: 0;
	        z-index: 9;
	    }
			.de-img {
				height: 180px;
				width: 33.333%;
				position: relative;
				margin-left: 20px;
			}
			.de-img img{
				height: 180px;
				width: 180px;
			}
			.de-img p{
				height: 30px;
				width: 30px;
				background: antiquewhite;
				position: absolute;
				top: -30px;
				left: -15px;
				z-index: 9;
				border-radius: 30px;
				text-align: center;
				line-height: 30px;
			}






			.lables-a{
				margin-left: 5%;
				margin-right: 5%;
				background: #fff;
				padding-bottom: 35px;
			}
			.lables-a .la-list-a{
				margin-top: 50px;
				width: 100%;
				margin-left: 20%;
				margin-right: 20%;
			}
			.first-a{
				border: 1px solid #c6c6c6;
				height: 400px;
				overflow-y:scroll;
			}
			.first-a .el-row{
				margin: 20px 10% 20px 10%;
			}
			.search-a input{
				width: 95%;
				height: 20px;
				margin-bottom: 10px;
				margin-left: 2%;
			}


			.lable-o-a{
				width: 47%;
				text-align: center;
				background: #c6c6c6;
				height: 30px;
				line-height: 30px;
				margin-bottom: 10px;
			}
			.choses{
				background: #f8f1da;
			}
			.chosess{
				background: #ff9400;
			}
			.right{
				float: right;
			}
			.left{
				float: left;
			}
			.two-a{
				border: 1px solid #c6c6c6;
				height: 400px;
				overflow-y:scroll;
			}
			.two-a .el-row{
				margin: 20px 10% 20px 10%;
			}
			.searchT-a{
				width: 80%;
				margin-left: 10%;
				height: 30px;
			}
			.centr{
				margin-top: 30%;
			}
			.centr img{
				width: 100px;
				height: 50px;
				margin-left: 35px;
			}
			.addother span{
				background-color: #FF9400;
				margin-left: 7px;
				padding: 5px 10px 5px 10px;

			}
			.addother{
				margin-top: 10px;
			}
</style>



// WEBPACK FOOTER //
// src/components/main/addf.vue